import { legacyApiResourceUrl } from "@ploy-lib/core";
import { BaseCamelCasedResource } from "./BaseResource";
export class GeneralInfoResource extends BaseCamelCasedResource {
    pk() {
        return `${this.productId}`;
    }
}
GeneralInfoResource.urlRoot = legacyApiResourceUrl("Product/GetGeneralInfo");
//# sourceMappingURL=GeneralInfoResource.js.map